import translationEnglish from './locales/en/translations.json';
import translationSinhala from './locales/lk/translations.json';

const translate = (componentPath: string, forceToSinhala: boolean = false) => {
  const keys = componentPath.split('.');
  let language = localStorage.getItem('defaultLang');

  if (forceToSinhala) {
    language = 'lk';
  }

  if (language && language === 'en') {
    return keys.reduce((accumulator: any, key: string) => {
      if (accumulator && key in accumulator) {
        return accumulator[key];
      }

      return undefined;
    }, translationEnglish);
  }

  return keys.reduce((accumulator: any, key: string) => {
    if (accumulator && key in accumulator) {
      return accumulator[key];
    }

    return undefined;
  }, translationSinhala);
};

export default translate;
